import { render, staticRenderFns } from "./si_CameraButton.vue?vue&type=template&id=0997bbad&scoped=true&"
import script from "./si_CameraButton.vue?vue&type=script&lang=js&"
export * from "./si_CameraButton.vue?vue&type=script&lang=js&"
import style0 from "./si_CameraButton.vue?vue&type=style&index=0&id=0997bbad&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0997bbad",
  null
  
)

export default component.exports